import React, { useContext } from "react";
import { Typography } from "@mui/material";

import PageLayout from "@/components/layouts/page/PageLayout";
import BrandDirectMailCampaignList from "../components/BrandDirectMailCampaignList";
import { GlobalContext } from "@/helpers/contexts/contexts";

const BrandDirectMailCampaignListPage = () => {
  const { selectedBrand, loggedInUser } = useContext(GlobalContext);

  return (
    <PageLayout className="admin-dashboard-container mx-0 mx-sm-2">
      <div className="dashboard participant-dashboard">
        <Typography variant="h5" className="widget-title mb-4 mb-md-auto">
          Direct Mail
        </Typography>
        <BrandDirectMailCampaignList
          selectedBrand={selectedBrand}
          loggedInUser={loggedInUser}
        />
      </div>
    </PageLayout>
  );
};

export default BrandDirectMailCampaignListPage;
